var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isModalOpen
    ? _c(
        "div",
        {
          staticClass: "modal fade in modal-open modal--featured-vendor",
          on: {
            click: function($event) {
              if ($event.target !== $event.currentTarget) {
                return null
              }
              $event.stopPropagation()
              return _vm.closeModal($event)
            }
          }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "modal__header modal__vendor--header modal__header--vendor-bg"
                },
                [
                  _c("div", { staticClass: "modal__header--angles" }, [
                    _c("div", { staticClass: "modal__close-btn" }, [
                      _c("i", {
                        staticClass: "fa fa-times",
                        on: {
                          click: function($event) {
                            if ($event.target !== $event.currentTarget) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.closeModal($event)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "modal__vendor--logo",
                      attrs: { src: _vm.modalData.logoURL }
                    }),
                    _vm._v(" "),
                    _vm.modalData.overviewURL
                      ? _c(
                          "button",
                          {
                            staticClass: "modal__download-btn",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.downloadOverview($event)
                              }
                            }
                          },
                          [_vm._v("Download vendor PDF")]
                        )
                      : _c("div", { staticClass: "modal__no-file" }, [
                          _vm._v("Sorry, no file available!")
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal__body" }, [
                _c("div", { staticClass: "container-fluid" }, [
                  _vm.modalData.videoURL !== ""
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "modal__contact-row modal__contact-row--video"
                        },
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "modal__video-container",
                            domProps: {
                              innerHTML: _vm._s(_vm.modalData.videoURL)
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.modalData.featuredDocs.length > 0
                    ? _c(
                        "div",
                        { staticClass: "modal__feature-vendor-row" },
                        _vm._l(_vm.modalData.featuredDocs, function(
                          doc,
                          index
                        ) {
                          return _c("VendorDoc", {
                            key: index,
                            attrs: { doc: doc }
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modal__contact-row modal__contact-row--doc"
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.modalData,
                              expression: "modalData"
                            }
                          ],
                          staticClass: "modal__contact-msg-box--doc"
                        },
                        [
                          _c("div", { staticClass: "modal__contact-msg-box" }, [
                            _c("div", { staticClass: "col-sm-12" }, [
                              _c("img", {
                                staticClass: "modal__profile-pic--vendor",
                                attrs: { src: _vm.rm.headshot }
                              }),
                              _vm._v(
                                "\n                  Please contact your Regional Manager for more information about this vendor.\n                "
                              )
                            ])
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.fuelEmployee
                    ? _c(
                        "div",
                        {
                          staticClass: "modal__form-placeholder",
                          on: { click: _vm.closeModal }
                        },
                        [_vm._v("Only members can send messages to RMs.")]
                      )
                    : _c(
                        "form",
                        {
                          attrs: {
                            name: "getContractInfo",
                            id: "getContractInfo"
                          }
                        },
                        [
                          _c("div", { staticClass: "modal__contact-row" }, [
                            _c("div", { staticClass: "col-sm-12" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.text,
                                    expression: "text"
                                  }
                                ],
                                staticClass:
                                  "modal__comment-block modal__comment-block--vendor",
                                attrs: {
                                  name: "message",
                                  placeholder: "Message"
                                },
                                domProps: { value: _vm.text },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.text = $event.target.value
                                  }
                                }
                              })
                            ])
                          ])
                        ]
                      )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__footer" }, [
                _vm.isSending
                  ? _c(
                      "div",
                      { staticClass: "modal__sending-overlay" },
                      [
                        _c("MoonLoader", {
                          attrs: { size: "25px", color: "#1176BB" }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "modal__send-btn",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.sendMessage($event)
                          }
                        }
                      },
                      [
                        _vm._v("Send "),
                        _c("span", {
                          staticClass: "glyphicon glyphicon-send",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
              ])
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "modal__contact-row modal__contact-row--video-loading" },
      [_c("i", { staticClass: "fas fa-film" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }